<template>
  <div class="oilslist">
    <oils-list :allOrder='2'></oils-list>
  </div>
</template>
<script>
import OilsList from './oilsList';
export default {
  components:{
    OilsList
  }
}
</script>
<style lang="scss" scoped>
.oilslist{
  height: 100%;
  overflow: auto;
}
</style>